export const versionStatus = {
  DRAFT: 'DRAFT',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
  PENDING: 'PENDING',
};
